import { render } from "./RedDieselTotals.vue?vue&type=template&id=60e03dc0&scoped=true"
import script from "./RedDieselTotals.vue?vue&type=script&lang=js"
export * from "./RedDieselTotals.vue?vue&type=script&lang=js"

import "./RedDieselTotals.vue?vue&type=style&index=0&id=60e03dc0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e03dc0"]])

export default __exports__